import {Action} from '@ngrx/store';
import {
  WorkHistoryAndPortfolioDTO,
  PortfolioFileDTO,
  PortfolioFileDeletionDTO,
  PortfolioFileGetDTO
} from '@staff-app/models/portfolioDTO';

export enum PortfolioActionTypes {
  GetWorkHistoryAndPortfolios = '[Portfolio] Get Work History And Portfolios',
  GetWorkHistoryAndPortfoliosSuccessful = '[Portfolio] Get Work History And Portfolios Successful',
  SaveWorkHistoryAndPortfolios = '[Portfolio] Save Work History And Portfolios',
  SaveWorkHistoryAndPortfoliosSuccessful = '[Portfolio] Save Work History And Portfolios Successful',
  GetPortfolioFiles = '[Portfolio] Get Portfolios Files',
  GetPortfolioFilesSuccessful = '[Portfolio] Get Portfolios Files Successful',
  SavePortfolioFile = '[Portfolio] Save Portfolios File',
  SavePortfolioFileSuccessful = '[Portfolio] Save Portfolios File Successful',
  RemovePortfolioFile = '[Portfolio] Delete Portfolios File',
  RemovePortfolioFileSuccessful = '[Portfolio] Delete Portfolios File Successful',
  NavigateAway = '[Portfolio] Navigate Away'
}

export class GetWorkHistoryAndPortfolios implements Action {
  readonly type = PortfolioActionTypes.GetWorkHistoryAndPortfolios;

  constructor(public payload: number) {}
}
export class GetWorkHistoryAndPortfoliosSuccessful implements Action {
  readonly type = PortfolioActionTypes.GetWorkHistoryAndPortfoliosSuccessful;

  constructor(public payload: WorkHistoryAndPortfolioDTO) {}
}
export class SaveWorkHistoryAndPortfolios implements Action {
  readonly type = PortfolioActionTypes.SaveWorkHistoryAndPortfolios;

  constructor(
    public payload: WorkHistoryAndPortfolioDTO,
    public isEditMode = false
  ) {}
}
export class SaveWorkHistoryAndPortfoliosSuccessful implements Action {
  readonly type = PortfolioActionTypes.SaveWorkHistoryAndPortfoliosSuccessful;

  constructor() {}
}
export class GetPortfolioFiles implements Action {
  readonly type = PortfolioActionTypes.GetPortfolioFiles;

  constructor(public payload: number) {}
}
export class GetPortfolioFilesSuccessful implements Action {
  readonly type = PortfolioActionTypes.GetPortfolioFilesSuccessful;

  constructor(public payload: PortfolioFileGetDTO[]) {}
}
export class SavePortfolioFile implements Action {
  readonly type = PortfolioActionTypes.SavePortfolioFile;

  constructor(public payload: PortfolioFileDTO) {}
}
export class SavePortfolioFileSuccessful implements Action {
  readonly type = PortfolioActionTypes.SavePortfolioFileSuccessful;

  constructor(public payload: number) {}
}
export class RemovePortfolioFile implements Action {
  readonly type = PortfolioActionTypes.RemovePortfolioFile;

  constructor(public payload: PortfolioFileDeletionDTO) {}
}
export class RemovePortfolioFileSuccessful implements Action {
  readonly type = PortfolioActionTypes.RemovePortfolioFileSuccessful;
  constructor(public payload: number) {}
}
export class NavigateAway implements Action {
  readonly type = PortfolioActionTypes.NavigateAway;

  constructor() {}
}
export type PortfolioActions =
  | GetWorkHistoryAndPortfolios
  | GetWorkHistoryAndPortfoliosSuccessful
  | SaveWorkHistoryAndPortfolios
  | SaveWorkHistoryAndPortfoliosSuccessful
  | GetPortfolioFiles
  | GetPortfolioFilesSuccessful
  | SavePortfolioFile
  | SavePortfolioFileSuccessful
  | RemovePortfolioFile
  | RemovePortfolioFileSuccessful
  | NavigateAway;
